module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("If the muse were mine to tempt it")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("And my feeble voice were strong")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("If my tongue were turned to measures,")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("I would sing a stirring song.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("I would sing a song heroic")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Of those noble sons of Ham,")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Of the gallant colored soldiers")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Who fought for Uncle Sam!")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("—Paul Laurence Dunbar,")]), _vm._v(" The Colored Soldiers"), _c('i', [_vm._v(", 1894")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226c2c02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epigraph.vue
// module id = 72
// module chunks = 0